"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMitek = exports.mockMitekDecision = void 0;
var deprecated_1 = require("./deprecated");
Object.defineProperty(exports, "mockMitekDecision", { enumerable: true, get: function () { return deprecated_1.mockMitekDecision; } });
var useMitek_1 = require("./hooks/useMitek");
Object.defineProperty(exports, "useMitek", { enumerable: true, get: function () { return useMitek_1.useMitek; } });
//# sourceMappingURL=index.js.map